var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center gap-4 animate-pulse",attrs:{"role":"status"}},[_c('div',{staticClass:"h-9 bg-gray-lightest rounded w-[80%]"}),_vm._v(" "),_c('div',{staticClass:"h-9 bg-gray-lightest rounded w-[60%]"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }